import {
  DATA_SOURCE_TYPES,
  GOVERNANCE_SUPPORTED_DATASOURCES,
  MIXED_DATASOURCES,
  STRUCTURED_DATASOURCES,
  UNSTRUCTURED_DATASOURCES,
  URL_DATA_SOURCES_STRUCTURED,
  URL_INSIGHTS,
  RISK_SCORE_NOT_SUPPORTED_DATASOURCES
} from '../../../../constants'
import { DashboardCategory } from '../../mainDashboardv2/slice'
import { GridArea } from '../types/interfaces'
import DataSourcesRiskyWidget from '../../mainDashboardv2/widgets/datasourcesRisky'
import LiveDataDiscovery from '../../mainDashboardv2/widgets/liveDataDiscovery'
import PolicyStatus from '../../mainDashboardv2/widgets/policyStatus'
import PrivacyRightsWidget from '../../mainDashboardv2/widgets/privacyOpsWidgets/privacyRightsWidget'
import ClassificationAndLabelWidget from '../../mainDashboardv2/widgets/classificationAndLabelingWidget'
import EntitiesRisky from '../../mainDashboardv2/widgets/entitiesRisky'
import AlertsSummaryWidget from '../../mainDashboardv2/widgets/alertsSummary'
import PrivacyAssessmentsWidget from '../../mainDashboardv2/widgets/privacyOpsWidgets/privacyAssessmentsWidget'
import OverviewWidget from '../../mainDashboardv2/widgets/datasourceWidgets/overviewWidget'
import DataSourceRiskScoreWidget from '../../mainDashboardv2/widgets/datasourceWidgets/dataSourceRiskScoreWidget'
import StructuredSummaryWidget from '../../../dataSources/structuredSummaryWidget'
import UnstructuredSummaryWidget from '../../../dataSources/unstructuredSummaryWidget'
import AttributesDashboardWidget from '../../../attributes/attributesDashboardWidgetV2'
import ScannedDataWidgets from '../../../scannedData/scannedDataWidgets'
import Access360Widget from '../../mainDashboardv2/widgets/access360Widget'
import DuplicateDataWidget from '../../mainDashboardv2/widgets/duplicateData'
import UserCountsWidget from '../../mainDashboardv2/widgets/userCounts'
import RiskScoreDsWidget from '../../../configureRiskScore/riskScoreDsWidget/riskScoreDsWidget'
import MixedSummaryCountWidget from '../../../ObjectTypeAndPolicies/objectTypeAndPolicies'
import StructuredOverviewWidget from '../../mainDashboardv2/widgets/datasourceWidgets/structuredOverviewWidget'
import { getFeatureConfig } from '../../../../configs/featureConfig'
import { FeatureFlags } from '../../../../configs/featureFlagSlice'
import { isRiskScoreEnabled } from '../../../configureRiskScore/riskScoreSelectors'
import { store } from '../../../../index'
import CompanyWideActivityWidget from '../../mainDashboardv2/widgets/datasourceWidgets/companyWideActivityWidget'
import DSRSummaryWidget from '../../../privacyOpsOverview/widgets/DSRSummaryWidget'
import NeedAttentionWidget from '../../../privacyOpsOverview/widgets/NeedAttentionWidget'
import RopaSummaryWidget from '../../../privacyOpsOverview/widgets/RopaSummary'
import DSRTypesWidget from '../../../privacyOpsOverview/widgets/DSRTypesWidget'
import RisksBasedOnGroupsWidget from '../../../privacyOpsOverview/widgets/RisksBasedOnGroupsWidget'
import ProcessesBasedOnGroupsWidget from '../../../privacyOpsOverview/widgets/ProcessesBasedOnGroupsWidget'
import ConsentsByTypeWidget from '../../../consentManagement/overview/consentsByTypeWidget'
import ConsentsByRegion from '../../../cookieConsent/overview/components/consentsByRegion'
import PiaWidget from '../../../privacyOpsOverview/widgets/piaWidget'
import AccessRelatedDataForFiles from '../../complainceDashboards/pciDashboard/widgets/accessRelatedDataForFiles/accessRelatedDataForFiles'
import DatabasesWithPCIData from '../../complainceDashboards/pciDashboard/widgets/databasesWithPCIData/databasesWithPCIData'
import FilesDistributionByPCILabels from '../../complainceDashboards/pciDashboard/widgets/filesDistributionByPCILabels/filesDistributionByPCILabels'
import FilesDistributionByTime from '../../complainceDashboards/pciDashboard/widgets/filesDistributionByTime/filesDistributionByTime'
import FilesWithPCIData from '../../complainceDashboards/pciDashboard/widgets/filesWithPCIData/filesWithPCIData'
import PCIComplianceSummary from '../../complainceDashboards/pciDashboard/widgets/pciComplianceSummary/pciComplianceSummary'
import PCIDataSharedWithPartners from '../../complainceDashboards/pciDashboard/widgets/pciDataSharedWithPartners/pciDataSharedWithPartners'
import SiteOverview from '../../template1/widget/SiteOverview'
import { ComplianceDashboardTypes } from '../../complainceDashboards/constants'
import { IntlShape } from 'react-intl'

export const DashboardWidgetType = {
  RISK_SUMMARY: 'risk-summary',
  SCANNED_DATA_SUMMARY: 'scanned-data-summary',
  POLICY_STATUS: 'policy-status',
  POLICY_RIGHTS: 'policy-rights',
  CLASSIFICATIONS_OR_LABELS: 'classifications-or-labels',
  ENTITIES_SUMMARY: 'entities-summary',
  ALERTS_SUMMARY: 'alerts-summary',
  POLICY_ASSESSMENTS: 'policy-assessments',
  STRUCTURED_SUMMARY: 'structured-summary',
  UNSTRUCTURED_SUMMARY: 'unstructured-summary',
  ACCESS_360: 'access-360',
  RISK_SCORE: 'risk-score',
  DATA_SOURCE_OVERVIEW: 'datasource-overview',
  DATA_SOURCE_RISK_SCORE: 'datasource-risk-score',
  DATA_SOURCE_HIGH_ATTRIBUTES: 'datasource-high-attributes',
  DATA_SOURCE_ALL_ATTRIBUTES: 'datasource-all-attributes',
  DATA_SOURCE_CLASSIFICATIONS_OR_LABELS: 'datasource-classifications-or-labels',
  DATA_SOURCE_SCANNED_DATA: 'datasource-scanned-data',
  DATA_SOURCE_ACCESS_360: 'datasource-access-360',
  DATA_SOURCE_MIXED_SUMMARY_COUNT: 'datasource-mixed-summary-count',
  DATA_SOURCE_STRUCTURED_SUMMARY_COUNT: 'datasource-structured-summary-count',
  DATA_SOURCE_ENTITIES_SUMMARY: 'datasource-entities-summary',
  DATA_SOURCE_UNSTRUCTURED_SUMMARY: 'datasource-unstructured-summary',
  COMPANY_WIDE_ACTIVITY: 'po-company-wide-activity',
  PO_DATA_SUBJECT_REQUEST_SUMMARY: 'po-data-subject-request-summary',
  PO_DATA_SUBJECT_REQUEST_TYPES: 'po-data-subject-request-types',
  PO_NEED_ATTENTION: 'po-need-attention',
  PO_CONSENT_MANAGEMENT: 'po-consent-management',
  PO_COOKIE_CONSENT: 'po-cookie-consent',
  PO_PRIVACY_IMPACT_ASSESSMENTS: 'po-privacy-impact-assessments',
  PO_PIA_RISKS_BASED_ON_GROUPS: 'po-pia-risks-based-on-groups',
  PO_ROPA_SUMMARY: 'po-ropa-summary',
  PO_PROCESSES_BASED_ON_GROUPS: 'po-processes-based-on-groups',
  PCI_COMPLIANCE_SUMMARY: 'pci-compliance-summary',
  FILES_WITH_PCI_DATA: 'files-with-pci-data',
  DATABASES_WITH_PCI_DATA: 'databases-with-pci-data',
  FILES_DISTRIBUTION_BY_PCI_LABELS: 'files-distribution-by-pci-labels',
  PCI_DATA_SHARED_WITH_PARTNERS: 'pci-data-shared-with-partners',
  HIPAA_COMPLIANCE_SUMMARY: 'hipaa-compliance-summary',
  FILES_WITH_HIPAA_DATA: 'files-with-hipaa-data',
  DATABASES_WITH_HIPAA_DATA: 'databases-with-hipaa-data',
  FILES_DISTRIBUTION_BY_HIPAA_LABELS: 'files-distribution-by-hipaa-labels',
  HIPAA_DATA_SHARED_WITH_PARTNERS: 'hipaa-data-shared-with-partners',
  ACCESS_RELATED_DATA_FOR_FILES: 'access-related-data-for-files',
  FILES_DISTRIBUTION_BY_TIME: 'files-distribution-by-time',
  SITE_OVERVIEW_DRIVE: 'site-overview-drive',
  SITE_OVERVIEW_SHAREPOINT: 'site-overview-sharepoint',
  DUPLICATE_DATA: 'duplicate-data',
  USER_COUNTS: 'user-counts'
}

export type DashboardWidgetType = typeof DashboardWidgetType[keyof typeof DashboardWidgetType]

export type WidgetIsEnabledType = {
  featureFlags: FeatureFlags
  datasourceType?: DATA_SOURCE_TYPES
}
export interface WidgetMap {
  [key: string]: {
    component: any
    isEnabled?: (params: WidgetIsEnabledType) => boolean
    defaultProps?: { [key: string]: any }
    supportedDashboardType?: DashboardCategory[]
    supportedDatasourceType?: DATA_SOURCE_TYPES[]
    widgetName?: string
    id?: string
    gridArea?: GridArea
    widgetType?: DashboardWidgetType
  }
}

const ATTRIBUTE_DASHBOARD_WIDGETS_CHART_SIZE = 132
const CLASSIFICATIONS_WIDGETS_CHART_SIZE = 132
const RISKY_ENTITIES_WIDGETS_CHART_SIZE = 164

const getWidgetId = (widgetType: string) => `widget-${widgetType}`

const getWidgetMap = (intl: IntlShape): WidgetMap => ({
  [DashboardWidgetType.RISK_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.RISK_SUMMARY),
    widgetType: DashboardWidgetType.RISK_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: DataSourcesRiskyWidget,
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: intl.formatMessage({ id: 'dataSources.widget.risk.title' })
  },
  [DashboardWidgetType.SCANNED_DATA_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.SCANNED_DATA_SUMMARY),
    widgetType: DashboardWidgetType.SCANNED_DATA_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: LiveDataDiscovery,
    defaultProps: { parentUrl: URL_INSIGHTS },
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: intl.formatMessage({ id: 'scannedData.widget.title' })
  },
  [DashboardWidgetType.POLICY_STATUS]: {
    id: getWidgetId(DashboardWidgetType.POLICY_STATUS),
    widgetType: DashboardWidgetType.POLICY_STATUS,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: PolicyStatus,
    supportedDashboardType: [
      DashboardCategory.main_dashboard,
      DashboardCategory.datasource_summary_dashboard
    ],
    supportedDatasourceType: [
      ...STRUCTURED_DATASOURCES,
      ...UNSTRUCTURED_DATASOURCES,
      ...MIXED_DATASOURCES
    ],
    widgetName: intl.formatMessage({ id: 'policyStatus.widget.title' })
  },
  [DashboardWidgetType.POLICY_RIGHTS]: {
    id: getWidgetId(DashboardWidgetType.POLICY_RIGHTS),
    widgetType: DashboardWidgetType.POLICY_RIGHTS,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: PrivacyRightsWidget,
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: intl.formatMessage({ id: 'privacyOpsWidget.privacyRights' })
  },
  [DashboardWidgetType.CLASSIFICATIONS_OR_LABELS]: {
    id: getWidgetId(DashboardWidgetType.CLASSIFICATIONS_OR_LABELS),
    widgetType: DashboardWidgetType.CLASSIFICATIONS_OR_LABELS,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: ClassificationAndLabelWidget,
    defaultProps: { parentUrl: URL_INSIGHTS },
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: `${intl.formatMessage({ id: 'document.widget.title' })} ${intl.formatMessage({
      id: 'document.widget.title.labels'
    })}`
  },
  [DashboardWidgetType.ENTITIES_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.ENTITIES_SUMMARY),
    widgetType: DashboardWidgetType.ENTITIES_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: EntitiesRisky,
    defaultProps: { parentUrl: URL_INSIGHTS },
    supportedDashboardType: [
      DashboardCategory.main_dashboard,
      DashboardCategory.datasource_summary_dashboard
    ],
    supportedDatasourceType: [...UNSTRUCTURED_DATASOURCES],
    widgetName: intl.formatMessage({ id: 'entities.title' })
  },
  [DashboardWidgetType.ALERTS_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.ALERTS_SUMMARY),
    widgetType: DashboardWidgetType.ALERTS_SUMMARY,
    gridArea: {
      rowSpan: 2,
      colSpan: 1
    },
    component: AlertsSummaryWidget,
    supportedDashboardType: [
      DashboardCategory.main_dashboard,
      DashboardCategory.datasource_summary_dashboard
    ],
    supportedDatasourceType: [
      ...STRUCTURED_DATASOURCES,
      ...UNSTRUCTURED_DATASOURCES,
      ...MIXED_DATASOURCES
    ],
    widgetName: intl.formatMessage({ id: 'alerts.widget.title' })
  },
  [DashboardWidgetType.POLICY_ASSESSMENTS]: {
    id: getWidgetId(DashboardWidgetType.POLICY_ASSESSMENTS),
    widgetType: DashboardWidgetType.POLICY_ASSESSMENTS,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: PrivacyAssessmentsWidget,
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: intl.formatMessage({ id: 'privacyOpsWidget.privacyAssessments' })
  },
  [DashboardWidgetType.STRUCTURED_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.STRUCTURED_SUMMARY),
    widgetType: DashboardWidgetType.STRUCTURED_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: StructuredSummaryWidget,
    supportedDashboardType: [
      DashboardCategory.main_dashboard,
      DashboardCategory.datasource_summary_dashboard
    ],
    supportedDatasourceType: [...MIXED_DATASOURCES, ...STRUCTURED_DATASOURCES],
    widgetName: intl.formatMessage({ id: 'dataSources.widget.structured.title' }),
    isEnabled: ({ datasourceType }) => {
      if (!datasourceType) {
        return true
      }

      return !getFeatureConfig(datasourceType).dashboard.widgetStructuredData.isHidden
    }
  },
  [DashboardWidgetType.UNSTRUCTURED_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.UNSTRUCTURED_SUMMARY),
    widgetType: DashboardWidgetType.UNSTRUCTURED_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: UnstructuredSummaryWidget,
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: intl.formatMessage({ id: 'dataSources.widget.unstructured.title' })
  },
  [DashboardWidgetType.ACCESS_360]: {
    id: getWidgetId(DashboardWidgetType.ACCESS_360),
    widgetType: DashboardWidgetType.ACCESS_360,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: Access360Widget,
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: intl.formatMessage({ id: 'accessControl.access360' }),
    isEnabled: ({ featureFlags }) => featureFlags?.accessControl
  },

  [DashboardWidgetType.RISK_SCORE]: {
    id: getWidgetId(DashboardWidgetType.RISK_SCORE),
    widgetType: DashboardWidgetType.RISK_SCORE,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: RiskScoreDsWidget,
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: intl.formatMessage({ id: 'widget.maindashboard.risk.score.title' }),
    isEnabled: () => {
      const state = store.getState()
      return isRiskScoreEnabled(state)
    }
  },

  [DashboardWidgetType.DATA_SOURCE_OVERVIEW]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_OVERVIEW),
    widgetType: DashboardWidgetType.DATA_SOURCE_OVERVIEW,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: OverviewWidget,
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [...UNSTRUCTURED_DATASOURCES],
    widgetName: intl.formatMessage({ id: 'dataSources.widget.overview.title' })
  },
  [DashboardWidgetType.DATA_SOURCE_RISK_SCORE]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_RISK_SCORE),
    widgetType: DashboardWidgetType.DATA_SOURCE_RISK_SCORE,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: DataSourceRiskScoreWidget,
    defaultProps: {
      parentClassName: 'xs-p-0'
    },
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [...UNSTRUCTURED_DATASOURCES].filter(
      (type) => !RISK_SCORE_NOT_SUPPORTED_DATASOURCES.includes(type)
    ),
    widgetName: intl.formatMessage({ id: 'dataSources.widget.riskScore.title' }),
    isEnabled: ({ datasourceType }) => {
      const state = store.getState()
      return (
        isRiskScoreEnabled(state) &&
        !RISK_SCORE_NOT_SUPPORTED_DATASOURCES.includes(datasourceType as DATA_SOURCE_TYPES)
      )
    }
  },
  [DashboardWidgetType.DATA_SOURCE_HIGH_ATTRIBUTES]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_HIGH_ATTRIBUTES),
    widgetType: DashboardWidgetType.DATA_SOURCE_HIGH_ATTRIBUTES,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: AttributesDashboardWidget,
    defaultProps: {
      isHighSensitive: true,
      legendPosition: 'right',
      showListLegend: false,
      chartSize: ATTRIBUTE_DASHBOARD_WIDGETS_CHART_SIZE
    },
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [
      ...STRUCTURED_DATASOURCES,
      ...UNSTRUCTURED_DATASOURCES,
      ...MIXED_DATASOURCES
    ],
    widgetName: `${intl.formatMessage({
      id: 'attributes.widget.distribution.title'
    })} ${intl.formatMessage({ id: 'attributes.widget.distribution.sensitivity' })}`
  },
  [DashboardWidgetType.DATA_SOURCE_ALL_ATTRIBUTES]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_ALL_ATTRIBUTES),
    widgetType: DashboardWidgetType.DATA_SOURCE_ALL_ATTRIBUTES,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: AttributesDashboardWidget,
    defaultProps: {
      isHighSensitive: false,
      legendPosition: 'right',
      showListLegend: false,
      chartSize: ATTRIBUTE_DASHBOARD_WIDGETS_CHART_SIZE
    },
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [
      ...STRUCTURED_DATASOURCES,
      ...UNSTRUCTURED_DATASOURCES,
      ...MIXED_DATASOURCES
    ],
    widgetName: `${intl.formatMessage({
      id: 'attributes.widget.distribution.title'
    })} ${intl.formatMessage({ id: 'attributes.widget.distribution.all' })}`
  },
  [DashboardWidgetType.DATA_SOURCE_CLASSIFICATIONS_OR_LABELS]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_CLASSIFICATIONS_OR_LABELS),
    widgetType: DashboardWidgetType.DATA_SOURCE_CLASSIFICATIONS_OR_LABELS,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: ClassificationAndLabelWidget,
    defaultProps: {
      labelChartSize: CLASSIFICATIONS_WIDGETS_CHART_SIZE,
      classificationChartSize: CLASSIFICATIONS_WIDGETS_CHART_SIZE
    },
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [...UNSTRUCTURED_DATASOURCES, ...MIXED_DATASOURCES],
    widgetName: `${intl.formatMessage({ id: 'document.widget.title' })} ${intl.formatMessage({
      id: 'document.widget.title.labels'
    })}`
  },
  [DashboardWidgetType.DATA_SOURCE_SCANNED_DATA]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_SCANNED_DATA),
    widgetType: DashboardWidgetType.DATA_SOURCE_SCANNED_DATA,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: ScannedDataWidgets,
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [
      ...STRUCTURED_DATASOURCES,
      ...UNSTRUCTURED_DATASOURCES,
      ...MIXED_DATASOURCES
    ],
    widgetName: intl.formatMessage({ id: 'scannedData.widget.title' })
  },
  [DashboardWidgetType.DATA_SOURCE_ACCESS_360]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_ACCESS_360),
    widgetType: DashboardWidgetType.DATA_SOURCE_ACCESS_360,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: Access360Widget,
    defaultProps: {
      chartBarAlignment: 'vertical'
    },
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [...GOVERNANCE_SUPPORTED_DATASOURCES],
    widgetName: intl.formatMessage({ id: 'accessControl.access360' }),
    isEnabled: ({ featureFlags, datasourceType }) =>
      featureFlags?.accessControl &&
      GOVERNANCE_SUPPORTED_DATASOURCES.includes(datasourceType as DATA_SOURCE_TYPES)
  },
  [DashboardWidgetType.DATA_SOURCE_STRUCTURED_SUMMARY_COUNT]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_STRUCTURED_SUMMARY_COUNT),
    widgetName: intl.formatMessage({ id: 'dataSources.widget.overview.title' }),
    widgetType: DashboardWidgetType.DATA_SOURCE_STRUCTURED_SUMMARY_COUNT,
    component: StructuredOverviewWidget,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [...STRUCTURED_DATASOURCES]
  },
  [DashboardWidgetType.DATA_SOURCE_MIXED_SUMMARY_COUNT]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_MIXED_SUMMARY_COUNT),
    widgetName: intl.formatMessage({ id: 'dataSources.widget.overview.title' }),
    widgetType: DashboardWidgetType.DATA_SOURCE_MIXED_SUMMARY_COUNT,
    component: MixedSummaryCountWidget,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [...MIXED_DATASOURCES]
  },
  [DashboardWidgetType.DATA_SOURCE_ENTITIES_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_ENTITIES_SUMMARY),
    widgetType: DashboardWidgetType.DATA_SOURCE_ENTITIES_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: EntitiesRisky,
    defaultProps: { chartPieWidth: RISKY_ENTITIES_WIDGETS_CHART_SIZE },
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [...STRUCTURED_DATASOURCES, ...MIXED_DATASOURCES],
    widgetName: intl.formatMessage({ id: 'entities.title' })
  },
  [DashboardWidgetType.DATA_SOURCE_UNSTRUCTURED_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.DATA_SOURCE_UNSTRUCTURED_SUMMARY),
    widgetType: DashboardWidgetType.DATA_SOURCE_UNSTRUCTURED_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    defaultProps: {
      isMixedDs: true,
      parentUrl: `${URL_DATA_SOURCES_STRUCTURED}/`
    },
    component: UnstructuredSummaryWidget,
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [...MIXED_DATASOURCES],
    widgetName: intl.formatMessage({ id: 'dataSources.widget.unstructured.title' })
  },
  [DashboardWidgetType.COMPANY_WIDE_ACTIVITY]: {
    id: getWidgetId(DashboardWidgetType.COMPANY_WIDE_ACTIVITY),
    widgetType: DashboardWidgetType.COMPANY_WIDE_ACTIVITY,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    isEnabled: ({ datasourceType, featureFlags }) => {
      if (!datasourceType) {
        return false
      }

      return featureFlags.actualAccess
    },
    component: CompanyWideActivityWidget,
    defaultProps: {
      parentClassName: 'xs-p-0'
    },
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [...GOVERNANCE_SUPPORTED_DATASOURCES],
    widgetName: intl.formatMessage({ id: 'dataSources.widget.companyWideActivity.title' })
  },
  [DashboardWidgetType.PO_DATA_SUBJECT_REQUEST_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.PO_DATA_SUBJECT_REQUEST_SUMMARY),
    widgetName: intl.formatMessage({ id: 'po.dashboard.dsrSummary.widget.title' }),
    widgetType: DashboardWidgetType.PO_DATA_SUBJECT_REQUEST_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: DSRSummaryWidget,
    supportedDashboardType: [DashboardCategory.privacy_ops_dashboard]
  },
  [DashboardWidgetType.PO_NEED_ATTENTION]: {
    id: getWidgetId(DashboardWidgetType.PO_NEED_ATTENTION),
    widgetName: intl.formatMessage({ id: 'po.dashboard.needAttention.widget.title' }),
    widgetType: DashboardWidgetType.PO_NEED_ATTENTION,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: NeedAttentionWidget,
    supportedDashboardType: [DashboardCategory.privacy_ops_dashboard]
  },
  [DashboardWidgetType.PO_ROPA_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.PO_ROPA_SUMMARY),
    widgetName: intl.formatMessage({ id: 'po.dashboard.ropaSummary.widget.title' }),
    widgetType: DashboardWidgetType.PO_ROPA_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: RopaSummaryWidget,
    supportedDashboardType: [DashboardCategory.privacy_ops_dashboard]
  },
  [DashboardWidgetType.PO_DATA_SUBJECT_REQUEST_TYPES]: {
    id: getWidgetId(DashboardWidgetType.PO_DATA_SUBJECT_REQUEST_TYPES),
    widgetName: intl.formatMessage({ id: 'po.dashboard.dsrTypes.widget.title' }),
    widgetType: DashboardWidgetType.PO_DATA_SUBJECT_REQUEST_TYPES,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: DSRTypesWidget,
    supportedDashboardType: [DashboardCategory.privacy_ops_dashboard]
  },
  [DashboardWidgetType.PO_PIA_RISKS_BASED_ON_GROUPS]: {
    id: getWidgetId(DashboardWidgetType.PO_PIA_RISKS_BASED_ON_GROUPS),
    widgetName: intl.formatMessage({ id: 'po.dashboard.riskBasedOnGroups.widget.title' }),
    widgetType: DashboardWidgetType.PO_PIA_RISKS_BASED_ON_GROUPS,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: RisksBasedOnGroupsWidget,
    supportedDashboardType: [DashboardCategory.privacy_ops_dashboard]
  },
  [DashboardWidgetType.PO_PROCESSES_BASED_ON_GROUPS]: {
    id: getWidgetId(DashboardWidgetType.PO_PROCESSES_BASED_ON_GROUPS),
    widgetName: intl.formatMessage({ id: 'po.dashboard.processBasedOnGroups.widget.title' }),
    widgetType: DashboardWidgetType.PO_PROCESSES_BASED_ON_GROUPS,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: ProcessesBasedOnGroupsWidget,
    supportedDashboardType: [DashboardCategory.privacy_ops_dashboard]
  },
  [DashboardWidgetType.PO_CONSENT_MANAGEMENT]: {
    id: getWidgetId(DashboardWidgetType.PO_CONSENT_MANAGEMENT),
    widgetName: intl.formatMessage({ id: 'consentManagement' }),
    widgetType: DashboardWidgetType.PO_CONSENT_MANAGEMENT,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    defaultProps: {
      showSummary: true,
      showPreferenceCenterDropdown: false,
      widgetTitle: intl.formatMessage({ id: 'consentManagement' }),
      totalLegendText: intl.formatMessage({ id: 'consentManagement.totalConsents' })
    },
    component: ConsentsByTypeWidget,
    supportedDashboardType: [DashboardCategory.privacy_ops_dashboard]
  },
  [DashboardWidgetType.PO_COOKIE_CONSENT]: {
    id: getWidgetId(DashboardWidgetType.PO_COOKIE_CONSENT),
    widgetName: intl.formatMessage({ id: 'privacyOpsWidget.cookieConsent' }),
    widgetType: DashboardWidgetType.PO_COOKIE_CONSENT,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    defaultProps: {
      showSummary: true,
      showDurationDropdown: false,
      widgetTitle: intl.formatMessage({ id: 'privacyOpsWidget.cookieConsent' })
    },
    component: ConsentsByRegion,
    supportedDashboardType: [DashboardCategory.privacy_ops_dashboard]
  },
  [DashboardWidgetType.PO_PRIVACY_IMPACT_ASSESSMENTS]: {
    id: getWidgetId(DashboardWidgetType.PO_PRIVACY_IMPACT_ASSESSMENTS),
    widgetName: intl.formatMessage({ id: 'po.dashboard.pia.widget.title' }),
    widgetType: DashboardWidgetType.PO_PRIVACY_IMPACT_ASSESSMENTS,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    defaultProps: { showSummary: true },
    component: PiaWidget,
    supportedDashboardType: [DashboardCategory.privacy_ops_dashboard]
  },
  // PCI Widgets
  [DashboardWidgetType.PCI_COMPLIANCE_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.PCI_COMPLIANCE_SUMMARY),
    widgetType: DashboardWidgetType.PCI_COMPLIANCE_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: PCIComplianceSummary,
    supportedDashboardType: [DashboardCategory.compliance_pci_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.widget.complianceSummary.title'
      },
      {
        type: ComplianceDashboardTypes.PCI
      }
    )
  },
  [DashboardWidgetType.FILES_WITH_PCI_DATA]: {
    id: getWidgetId(DashboardWidgetType.FILES_WITH_PCI_DATA),
    widgetType: DashboardWidgetType.FILES_WITH_PCI_DATA,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: FilesWithPCIData,
    supportedDashboardType: [DashboardCategory.compliance_pci_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.pci.widget.filesWithPCIData.title'
      },
      {
        type: ComplianceDashboardTypes.PCI
      }
    )
  },
  [DashboardWidgetType.DATABASES_WITH_PCI_DATA]: {
    id: getWidgetId(DashboardWidgetType.DATABASES_WITH_PCI_DATA),
    widgetType: DashboardWidgetType.DATABASES_WITH_PCI_DATA,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: DatabasesWithPCIData,
    supportedDashboardType: [DashboardCategory.compliance_pci_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.pci.widget.databasesWithPCIData.title'
      },
      {
        type: ComplianceDashboardTypes.PCI
      }
    )
  },
  [DashboardWidgetType.FILES_DISTRIBUTION_BY_PCI_LABELS]: {
    id: getWidgetId(DashboardWidgetType.FILES_DISTRIBUTION_BY_PCI_LABELS),
    widgetType: DashboardWidgetType.FILES_DISTRIBUTION_BY_PCI_LABELS,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: FilesDistributionByPCILabels,
    supportedDashboardType: [DashboardCategory.compliance_pci_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.pci.widget.filesDistributionByPCILabels.title'
      },
      {
        type: ComplianceDashboardTypes.PCI
      }
    )
  },
  [DashboardWidgetType.PCI_DATA_SHARED_WITH_PARTNERS]: {
    id: getWidgetId(DashboardWidgetType.PCI_DATA_SHARED_WITH_PARTNERS),
    widgetType: DashboardWidgetType.PCI_DATA_SHARED_WITH_PARTNERS,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: PCIDataSharedWithPartners,
    supportedDashboardType: [DashboardCategory.compliance_pci_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.pci.widget.dataSharedWithPartners.title'
      },
      {
        type: ComplianceDashboardTypes.PCI
      }
    )
  },
  [DashboardWidgetType.ACCESS_RELATED_DATA_FOR_FILES]: {
    id: getWidgetId(DashboardWidgetType.ACCESS_RELATED_DATA_FOR_FILES),
    widgetType: DashboardWidgetType.ACCESS_RELATED_DATA_FOR_FILES,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: AccessRelatedDataForFiles,
    supportedDashboardType: [DashboardCategory.compliance_pci_dashboard],
    widgetName: intl.formatMessage({
      id: 'compliance.dashboard.pci.widget.accessRelatedData.title'
    })
  },
  [DashboardWidgetType.FILES_DISTRIBUTION_BY_TIME]: {
    id: getWidgetId(DashboardWidgetType.FILES_DISTRIBUTION_BY_TIME),
    widgetType: DashboardWidgetType.FILES_DISTRIBUTION_BY_TIME,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: FilesDistributionByTime,
    supportedDashboardType: [DashboardCategory.compliance_pci_dashboard],
    widgetName: intl.formatMessage({
      id: 'compliance.dashboard.pci.widget.filesDistributionByTime.title'
    })
  },
  //HIPAA widgets
  [DashboardWidgetType.HIPAA_COMPLIANCE_SUMMARY]: {
    id: getWidgetId(DashboardWidgetType.HIPAA_COMPLIANCE_SUMMARY),
    widgetType: DashboardWidgetType.HIPAA_COMPLIANCE_SUMMARY,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: PCIComplianceSummary,
    defaultProps: {
      attributeSetName: 'HIPAA',
      complianceType: 'hipaa'
    },
    supportedDashboardType: [DashboardCategory.compliance_hipaa_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.widget.complianceSummary.title'
      },
      {
        type: ComplianceDashboardTypes.HIPAA
      }
    )
  },
  [DashboardWidgetType.FILES_WITH_HIPAA_DATA]: {
    id: getWidgetId(DashboardWidgetType.FILES_WITH_HIPAA_DATA),
    widgetType: DashboardWidgetType.FILES_WITH_HIPAA_DATA,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: FilesWithPCIData,
    defaultProps: {
      attributeSetName: 'HIPAA',
      complianceType: 'hippa'
    },
    supportedDashboardType: [DashboardCategory.compliance_hipaa_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.pci.widget.filesWithPCIData.title'
      },
      {
        type: ComplianceDashboardTypes.HIPAA
      }
    )
  },
  [DashboardWidgetType.DATABASES_WITH_HIPAA_DATA]: {
    id: getWidgetId(DashboardWidgetType.DATABASES_WITH_HIPAA_DATA),
    widgetType: DashboardWidgetType.DATABASES_WITH_HIPAA_DATA,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: DatabasesWithPCIData,
    defaultProps: {
      attributeSetName: 'HIPAA',
      complianceType: 'hippa'
    },
    supportedDashboardType: [DashboardCategory.compliance_hipaa_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.pci.widget.databasesWithPCIData.title'
      },
      {
        type: ComplianceDashboardTypes.HIPAA
      }
    )
  },
  [DashboardWidgetType.FILES_DISTRIBUTION_BY_HIPAA_LABELS]: {
    id: getWidgetId(DashboardWidgetType.FILES_DISTRIBUTION_BY_HIPAA_LABELS),
    widgetType: DashboardWidgetType.FILES_DISTRIBUTION_BY_HIPAA_LABELS,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: FilesDistributionByPCILabels,
    defaultProps: {
      attributeSetName: 'HIPAA',
      complianceType: 'hippa'
    },
    supportedDashboardType: [DashboardCategory.compliance_hipaa_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.pci.widget.filesDistributionByPCILabels.title'
      },
      {
        type: ComplianceDashboardTypes.HIPAA
      }
    )
  },
  [DashboardWidgetType.HIPAA_DATA_SHARED_WITH_PARTNERS]: {
    id: getWidgetId(DashboardWidgetType.HIPAA_DATA_SHARED_WITH_PARTNERS),
    widgetType: DashboardWidgetType.HIPAA_DATA_SHARED_WITH_PARTNERS,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: PCIDataSharedWithPartners,
    defaultProps: {
      attributeSetName: 'HIPAA',
      complianceType: 'hippa'
    },
    supportedDashboardType: [DashboardCategory.compliance_hipaa_dashboard],
    widgetName: intl.formatMessage(
      {
        id: 'compliance.dashboard.pci.widget.dataSharedWithPartners.title'
      },
      {
        type: ComplianceDashboardTypes.HIPAA
      }
    )
  },
  [DashboardWidgetType.ACCESS_RELATED_DATA_FOR_FILES]: {
    id: getWidgetId(DashboardWidgetType.ACCESS_RELATED_DATA_FOR_FILES),
    widgetType: DashboardWidgetType.ACCESS_RELATED_DATA_FOR_FILES,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: AccessRelatedDataForFiles,
    defaultProps: {
      attributeSetName: 'HIPAA',
      complianceType: 'hippa'
    },
    supportedDashboardType: [DashboardCategory.compliance_hipaa_dashboard],
    widgetName: intl.formatMessage({
      id: 'compliance.dashboard.pci.widget.accessRelatedData.title'
    })
  },
  [DashboardWidgetType.FILES_DISTRIBUTION_BY_TIME]: {
    id: getWidgetId(DashboardWidgetType.FILES_DISTRIBUTION_BY_TIME),
    widgetType: DashboardWidgetType.FILES_DISTRIBUTION_BY_TIME,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: FilesDistributionByTime,
    defaultProps: {
      complianceType: 'hippa'
    },
    supportedDashboardType: [DashboardCategory.compliance_hipaa_dashboard],
    widgetName: intl.formatMessage({
      id: 'compliance.dashboard.pci.widget.filesDistributionByTime.title'
    })
  },
  [DashboardWidgetType.SITE_OVERVIEW_SHAREPOINT]: {
    id: getWidgetId(DashboardWidgetType.SITE_OVERVIEW_SHAREPOINT),
    widgetType: DashboardWidgetType.SITE_OVERVIEW_SHAREPOINT,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: SiteOverview,
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [DATA_SOURCE_TYPES.sharePoint],
    widgetName: intl.formatMessage({ id: 'siteOverview.title' })
  },
  [DashboardWidgetType.SITE_OVERVIEW_DRIVE]: {
    id: getWidgetId(DashboardWidgetType.SITE_OVERVIEW_DRIVE),
    widgetType: DashboardWidgetType.SITE_OVERVIEW_DRIVE,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: SiteOverview,
    supportedDashboardType: [DashboardCategory.datasource_summary_dashboard],
    supportedDatasourceType: [DATA_SOURCE_TYPES.oneDrive],
    widgetName: intl.formatMessage({ id: 'driveOverview.title' })
  },
  [DashboardWidgetType.DUPLICATE_DATA]: {
    id: getWidgetId(DashboardWidgetType.DUPLICATE_DATA),
    widgetType: DashboardWidgetType.DUPLICATE_DATA,
    gridArea: {
      rowSpan: 1,
      colSpan: 2
    },
    component: DuplicateDataWidget,
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: intl.formatMessage({ id: 'duplicateData' })
  },
  [DashboardWidgetType.USER_COUNTS]: {
    id: getWidgetId(DashboardWidgetType.USER_COUNTS),
    widgetType: DashboardWidgetType.USER_COUNTS,
    gridArea: {
      rowSpan: 1,
      colSpan: 1
    },
    component: UserCountsWidget,
    supportedDashboardType: [DashboardCategory.main_dashboard],
    widgetName: intl.formatMessage({ id: 'widgetUserCounts' })
  }
})

export default getWidgetMap
